import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { BoardContainer } from "../BoardContainer";
import { AudioManager } from "../../../AudioManager";
import { BoardScene } from "../BoardScene";
import { Utils } from "../../../utils/Utils";

export class Chest extends Phaser.GameObjects.Container {

    public positionRect: Phaser.Geom.Rectangle;

    private chestImg: Phaser.GameObjects.Image;
    private halo: Phaser.GameObjects.Image;
    private hoverFX: Phaser.GameObjects.Sprite;
    private goldLabelContainer: Phaser.GameObjects.Container;
    private goldLabel: Phaser.GameObjects.Text;
    private goldCounter: number;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2 - 40;
        this.y = GameConstants.GAME_HEIGHT / 2 - 55;

        this.chestImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "chest_open");
        this.chestImg.setScale(.85);
        this.add(this.chestImg);

        this.halo = new Phaser.GameObjects.Sprite(this.scene, this.x, this.y, "texture_atlas_1", "chest_halo");
        this.halo.setScale(.85);
        this.halo.visible = false;
        this.halo.alpha = 0;

        const startTween = () => {

            if (!this.scene) {
                return;
            }

            const chain = this.scene.tweens.chain({
                targets: this.halo,
                tweens: [
                    {
                        alpha: 1,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 300
                    },
                    {
                        alpha: .4,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 1000,
                        onComplete: () => startTween(),
                        onCompleteScope: this
                    }
                ]
            });
            chain.play();
        };

        startTween();

        this.hoverFX = new Phaser.GameObjects.Sprite(this.scene, this.x - 25, this.y - 50, "texture_atlas_2", "fx_hover_chest_01");
        this.hoverFX.setScale(.85);
        this.scene.add.existing(this.hoverFX);
        this.hoverFX.play("chest_hover_fx");
        this.hoverFX.visible = false;

        this.positionRect = new Phaser.Geom.Rectangle(-150, -150, 250, 250);

        if (GameConstants.DEBUG) {
                
            const tmpGraphics = this.scene.add.graphics();
            tmpGraphics.lineStyle(2, 0xFFFF00, 2);  
            tmpGraphics.strokeRectShape(this.positionRect);
            this.add(tmpGraphics);
        }
    }

    public startGame(): void {

        this.goldLabelContainer = new Phaser.GameObjects.Container(this.scene, 0, 10);
        this.goldLabelContainer.x = GameConstants.GAME_WIDTH / 2 + 315;
        this.goldLabelContainer.y = GameConstants.GAME_HEIGHT / 2 + 465 * GameVars.scaleY;
        this.goldLabelContainer.scaleY = GameVars.scaleY;
        this.scene.add.existing(this.goldLabelContainer);

        const goldCounterBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "tab_coins");
        this.goldLabelContainer.add(goldCounterBackground);

        this.goldLabel = new Phaser.GameObjects.Text(this.scene, goldCounterBackground.x - 12, goldCounterBackground.y - 5, "0", { fontFamily: "AlmendraBold", fontSize: "42px", color: "#663227" });
        this.goldLabel.setOrigin(.5);
        this.goldLabelContainer.add(this.goldLabel);

        const state = GameVars.cardCrawlEngine.getState();

        this.goldCounter = state.lowerTableau[1].gold;

        this.goldLabel.text = this.goldCounter.toString();
    }

    public onGameOver(): void {

        this.goldLabel.text = this.goldCounter.toString();
    
        const floor = new Phaser.GameObjects.Image(this.scene, 0, 120, "texture_atlas_1", "floor_under_chest");
        floor.setScale(1.35);
        floor.alpha = 0;
        this.addAt(floor, 0);

        const delay = GameVars.victory ? BoardScene.DELAY_GAME_OVER : 0;

        this.scene.tweens.add({
            targets: this,
            x: 30,
            y: 90,
            scaleX: .8,
            scaleY: .8,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 2000,
            delay: 1500 + delay,
            onComplete: () => {

                this.scene.tweens.add({
                    targets: floor,
                    alpha: 1,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500
                });

                const duration = 1500;
                const delay = 1000;

                const hoverFX = new Phaser.GameObjects.Sprite(this.scene, -30, -65, "texture_atlas_2", "fx_hover_chest_01");
                hoverFX.setScale(.85);
                this.scene.add.existing(hoverFX);
                hoverFX.play("chest_hover_fx");
                this.add(hoverFX);

                // VACIAMOS EL CONTADOR
                this.scene.add.tween({
                    targets: this,
                    goldCounter: 0,
                    ease: Phaser.Math.Easing.Linear,
                    duration: 1500,
                    delay: 1000,
                    onUpdate: (tween, targets) => {

                        // EMITIMOS UNA MONEDA Y DEJAMOS DE EMITIR HACIA EL FINAL PARA QUE NO QUEDEN DESCOLGADAS DE LA ANIMACION DE LOS CONTADORES
                        if (tween.getValue() > 5 && Math.random() < .25) {

                            const p = Utils.getGlobalPosition(this.goldLabelContainer);

                            // emitir moneda
                            const coin = this.scene.add.image(p.x + 26, p.y, "texture_atlas_1", "coin");
                            coin.setScale(1.2, 1.2 * GameVars.scaleY);

                            const start = new Phaser.Math.Vector2(coin.x, coin.y);                    // Punto de inicio
                            const dx = 75 - 150 * Math.random();
                            const dy = -250 - 350 * Math.random();
                            const control = new Phaser.Math.Vector2(coin.x + dx, coin.y + dy);      // Punto de control para crear el arco
                            const end = new Phaser.Math.Vector2(GameConstants.GAME_WIDTH - 36, 36);   // Punto final, mismo que el de inicio

                            // Crear la curva de Bézier cuadrática
                            let curve = new Phaser.Curves.QuadraticBezier(start, control, end);

                            this.scene.tweens.add({
                                targets: coin,
                                t: { from: 0, to: 1 }, // Animar de 0 a 1 a lo largo de la curva
                                ease: Phaser.Math.Easing.Cubic.Out,
                                duration: 750,
                                onUpdate: (tween, targets) => {
                                    const t = tween.getValue();
                                    const point = curve.getPoint(t);
                                    targets.x = point.x;
                                    targets.y = point.y;
                                },
                                onComplete: () => {
                                    coin.destroy();
                                },
                                onCompleteScope: this
                            });

                            AudioManager.playSound("coin_emmited");
                        }
                    },
                    onUpdateScope: this,
                    onComplete: () => {
                        this.scene.tweens.add({
                            targets: this.goldLabelContainer,
                            alpha: .5,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 500,
                            delay: 1000
                        });
                    },
                    onCompleteScope: this
                });

                BoardScene.currentInstance.gameOverLayer.updateGold(duration, delay);
            },
            onCompleteHandler: this
        });

        // EL LETRERO CON EL ORO
        this.scene.tweens.add({
            targets: this.goldLabelContainer,
            x: GameConstants.GAME_WIDTH / 2 + 190,
            y: GameConstants.GAME_HEIGHT / 2 + 210 * GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 2000,
            delay: 1500 + delay
        });
    }

    public onActionProcessed(): void {
        
        const state = GameVars.cardCrawlEngine.getState();
        const previousState = GameVars.cardCrawlEngine.getPreviousState();

        if (state && previousState) {

            const previousGold = previousState.lowerTableau[1].gold;

            this.goldCounter = state.lowerTableau[1].gold;
    
            if (this.goldCounter > previousGold) {

                let delay = state.lowerTableau[1].uiData.performedAction === CardCrawl.CardType.STEAL ? 3500 : 1250;
    
                this.scene.time.delayedCall(delay, () => {

                    this.goldLabel.text = this.goldCounter.toString();
                    
                }, [], this);
            }  
        }

        this.halo.visible = false;
        this.hoverFX.visible = false;
    }

    public showAllowedMoves(cardData: CardCrawl.CardData): void {

        this.halo.visible = GameVars.allowedMoves.chest;

        BoardContainer.currentInstance.add(this.halo);
        BoardContainer.currentInstance.bringToTop(this.halo);
    }

    public hideAllowedMoves(): void {

        this.halo.visible = false;
    }

    public onCardOver(cardData: CardCrawl.CardData): void {

        if (!this.visible) {
            return;
        }

        if (!cardData || (cardData.type !== CardCrawl.CardType.GOLD && cardData.value)) {

            if (GameVars.allowedMoves.chest) {

                this.hoverFX.visible = true;
                this.hoverFX.alpha = 0;

                this.scene.tweens.add({
                    targets: this.hoverFX,
                    alpha: 1,
                    duration: 200,
                    ease: Phaser.Math.Easing.Cubic.Out
                });

                BoardContainer.currentInstance.add(this.hoverFX);
                BoardContainer.currentInstance.bringToTop(this.hoverFX);
            }

            this.halo.visible = false;
        }
    }

    public onCardOut(): void {

        if (!this.visible) {
            return;
        }

        if (this.hoverFX.visible) {

            this.scene.tweens.add({
                targets: this.hoverFX,
                alpha: 0,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                onComplete: () => {
                    this.hoverFX.visible = false;
                },
                onCompleteHandler: this
            });
        }
        
        this.halo.visible = GameVars.allowedMoves.chest;

        BoardContainer.currentInstance.add(this.halo);
        BoardContainer.currentInstance.bringToTop(this.halo);
    }
}
